module.exports = __webpack_public_path__ + "media/images/Logo-1-68e3e93211d85d31d919c96969f11fa6.png";